export default __webpack_public_path__ + "static/media/twitter_white.f8ad55fb.svg";